import React from "react"

import { Controller } from 'react-hook-form'

import { bool, arrayOf, object } from "prop-types"

import CustomSelect from "Pods/Shared/CustomSelect/CustomSelect"

import { printerTypeOptionShape } from "../../../../Utils/propTypes"

function PrinterUsedForm({
  control,
  printerTypeOptions,
  isFetchingPrinterTypes,
  userHavePermissions,
}) {
  return (
    <div className="use-cases-area__select-container use-cases-area__form-column">
      <span className="use-cases-area__label cgt-body-base-semibold cgt-mb-4">
        Printer used
      </span>
      <Controller
        name="printerType"
        control={control}
        render={({ field: { ref, ...fieldProps } }) => (
          <CustomSelect
            {...fieldProps}
            options={printerTypeOptions || []}
            placeholder="Select a 3D printer"
            disabled={
              !userHavePermissions ||
              isFetchingPrinterTypes ||
              printerTypeOptions.length === 0
            }
            isLoading={isFetchingPrinterTypes}
            className="use-cases-area__select cgt-body-base-semibold"
            searchable
          />
        )}
      />
    </div>
  )
}

PrinterUsedForm.propTypes = {
  control: object.isRequired,
  printerTypeOptions: arrayOf(printerTypeOptionShape).isRequired,
  isFetchingPrinterTypes: bool.isRequired,
  userHavePermissions: bool.isRequired,
}

export default PrinterUsedForm
